import { useEffect } from "react";
import styled from "styled-components";
import { TextField } from "@mui/material";
import { Text } from "../Text";
import { useTranslation } from "react-i18next";

const InputContainer = styled.div`
  width: 100%;
`;

const StyledInput = styled(TextField)`
  && {
    .MuiOutlinedInput-root {
      border-radius: 14px;
      height: 51px;
      background: transparent;
      border: 0;
    }

    .MuiOutlinedInput-notchedOutline {
      border: 0;
    }

    .MuiFormHelperText-root.Mui-error {
      text-align: ${(p) => (p.isRtl ? "right" : "left")};
    }

    .MuiInputBase-input {
      text-align: center;
      font-size: ${(p) => (p.fontSize ? p.fontSize : "inherit")};
    }

    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* input[type="checkbox"] :: {
      background: rgb(0, 85. 164)
    } */
  }
`;

const StyledDiv = styled.div(({ error, theme, height }) => ({
  borderRadius: 10,
  backgroundColor: theme.color.white,

  height: height ? height : "3em",
  border:
    !!error === true
      ? `1px solid ${theme.color.error}`
      : `1px solid ${theme.color.blue}`,
  fontSize: 16,
  display: "flex",
  paddingInlineEnd: "1em",
  paddingInlineStart: "1em",
  lineHeight: 1,
}));

const EndButton = styled.button(() => ({
  alignSelf: "center",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  minWidth: 44,
  minHeight: 44,
  // Keeps the row height the same as the bare 20px icon did
  margin: "-12px",
  marginInlineStart: "auto",
  padding: 0,
  border: "none",
  background: "transparent",
  cursor: "pointer",
}));

const StyleEndImg = styled.img(() => ({
  width: 20,
  height: 20,
}));

// TextField spreads unknown props onto its wrapper div, so attributes that belong on the <input>
// itself are moved into inputProps
const NATIVE_INPUT_PROPS = [
  "inputMode",
  "autoCapitalize",
  "autoCorrect",
  "spellCheck",
  "enterKeyHint",
  "maxLength",
  "minLength",
  "pattern",
  "min",
  "max",
  "step",
  "readOnly",
];

const splitNativeInputProps = (props) => {
  const nativeProps = {};
  const otherProps = {};
  Object.entries(props).forEach(([key, value]) => {
    if (NATIVE_INPUT_PROPS.includes(key) || key.startsWith("aria-")) {
      nativeProps[key] = value;
    } else {
      otherProps[key] = value;
    }
  });
  return [nativeProps, otherProps];
};

const StyleStartImg = styled.img(({ ...props }) => ({
  width: 22,
  height: 22,
  marginInlineEnd: "1em",
  alignSelf: "center",
}));

const inputLabelProps = {
  shrink: true,
  margin: "2rem",
};

const Label = styled(Text)``;

const InputMUI = ({
  label,
  placeholder,
  width = "full",
  isRtl,
  fontSize,
  validation,
  errorText,
  value,
  startImg,
  endImg,
  showPassword,
  helperText,
  inputProps,
  ...props
}) => {
  useEffect(() => {}, [value]);

  const { t } = useTranslation();
  const [nativeInputProps, textFieldProps] = splitNativeInputProps(props);
  const isPasswordHidden = props.type === "password";

  return (
    <InputContainer width={width}>
      {label && <Label>{label}</Label>}
      <StyledDiv error={!!helperText}>
        {!!startImg && <StyleStartImg src={startImg} alt="input-start-img" />}
        <StyledInput
          InputLabelProps={inputLabelProps}
          placeholder={placeholder || label}
          fullWidth={width === "full"}
          size="small"
          fontSize={fontSize}
          error={!!errorText}
          {...textFieldProps}
          inputProps={{ ...nativeInputProps, ...inputProps }}
          dir={isRtl === true ? "rtl" : "ltr"}
          isRtl={isRtl}
        />
        {!!endImg && (
          <EndButton
            type="button"
            aria-label={t(isPasswordHidden ? "common:show_password" : "common:hide_password")}
            aria-pressed={!isPasswordHidden}
            onClick={() => showPassword?.(isPasswordHidden)}
          >
            <StyleEndImg src={endImg} alt="" />
          </EndButton>
        )}
      </StyledDiv>
      <Text.Error style={{ textAlign: "start" }}>{t(helperText)}</Text.Error>
    </InputContainer>
  );
};

export default InputMUI;
